import React from 'react';
import { TakeOverSource } from '../utils/dialog';
import { TakeOverStatus } from '@/views/PatrolMode/types';
import classNames from 'classnames';
import { clstagStr } from '@/utils/util';
import { CLSTAG } from '@/utils/constant';
interface Props {
  isStoped: boolean;
  operatorIsSelf: boolean;
  takeOverSource: string;
  disabled: boolean;
  takeOverStatus: string;
  onShowMessage: (name: string) => void;
}
const Control = (props: Props) => {
  const { isStoped, disabled, operatorIsSelf, takeOverStatus } = props;
  const usable =
    operatorIsSelf &&
    isStoped &&
    !disabled &&
    takeOverStatus === TakeOverStatus.TAKEOVER;
  const handleClick = (e: any) => {
    if (usable) {
      props.onShowMessage('control');
    }
  };
  return (
    <li
      className='item control'
      onClick={handleClick}
      clstag={clstagStr(CLSTAG.RemoteControl)}
    >
      {usable ? <div className='img_normal' /> : <div className='img_gray' />}
      <h3 className='operate_key'>远程遥控</h3>
    </li>
  );
};
export default Control;
